module.exports = __webpack_public_path__ + "static/media/dashboard3.e85c2dc2.png";